import React, { useEffect, useState } from 'react'
import Layout from '../../components/global/Layout'
import Hero from '../../components/guide/Hero/Hero'
import SectionIntroTeacher from '../../components/guide/sections/SectionIntro/SectionIntroTeacher'
import SectionJelajahi from '../../components/guide/sections/SectionJelajahi/SectionJelajahi'
import SectionStats from '../../components/home/sections/SectionStats/SectionStats'
import { BASE_URL } from '../../utils/config'

function useStatisticBook() {
    const [statisticBook, setStatisticBook] = useState({});
    const [loadingStatisticBook, setLoadingStatisticBook] = useState(true);
    const [errorStatisticBook, setErrorStatisticBook] = useState(null);

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await fetch(`${BASE_URL}/api/statistic/getSummary`, {
                    cache: 'no-store',
                    headers: {
                        'Cache-Control': 'no-cache',
                        Pragma: 'no-cache',
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const responseData = await response.json();
                setStatisticBook(responseData);
                setLoadingStatisticBook(false);
            } catch (error) {
                setErrorStatisticBook(error);
                setLoadingStatisticBook(false);
            }
        }

        fetchData();
    }, []);
  
    return { statisticBook, errorStatisticBook, loadingStatisticBook };
}

const ForTeacher = () => {
    const { statisticBook } = useStatisticBook();

    const content = {
        subtitle: 'BUKU UNTUK GURU',
        title: 'Temukan referensi buku-buku resmi dari Kemendikdasmen',
        image: '/assets/image/guide/untuk guru.png',
        vector: '/assets/image/guide/vectorForTeacher.png',
        description: 'Akses berbagai referensi buku untuk membantu proses belajar mengajar Ibu/Bapak guru di seluruh Indonesia'
    }

    return (
        <Layout guide>
            <Hero content={content} role="teacher" />
            <SectionIntroTeacher />
            <SectionJelajahi />
            <SectionStats data={statisticBook} guide />
        </Layout>
    )
}

export default ForTeacher